import React, { useEffect } from 'react'
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import Typical from 'react-typical'
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomePageStyled = styled.header`
    width: 98%;
    height: 100vh;
    position: relative;
    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center; 
        width: 92%;
        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid #790079;
                    color: #790079;
                }
            }
            .i-linkedIn{
                &:hover{
                    border: 2px solid #0077b5;
                    color: #0077b5;
                }
            }
            .i-twitter{
                &:hover{
                    border: 2px solid #1DA1F2;
                    color: #1DA1F2;
                }
            }
            .i-instagram{
                &:hover{
                    border: 2px solid #bc2a8d;
                    color: #bc2a8d;
                }
            }
        }
        .anim{
            text-align:center !important;
            width: 0ch;
            overflow: hidden;
            white-space: nowrap;
            animation: text 8s steps(26) infinite alternate;
            border-right: 3px solid #13265d;
        }
        @keyframes text{
            0%{
                width: 0ch;
            }
            50%{
                width: 18ch;
            }
        }
    }
`;

const HomePage = () => {
    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    return (
        <div id="HomePage">
            <HomePageStyled>
                <div className="typography">
                    <h1 data-aos="fade-down">Hi, I'm <span>Ahsan Beg</span></h1>
                    <p style={{ fontSize: '22px' }}>I'm
                        <Typical
                            loop={Infinity}
                            wrapper='b'
                            steps={[
                                " a Full Stack Web Developer", 2000,
                                " an Avid Learner", 2000,
                            ]}
                        />
                    </p>
                    <div className="icons">
                        <a href="https://www.linkedin.com/in/ahsanbeg/" target="_blank" rel="noopener noreferrer" className="icon i-linkedIn" data-aos="fade-right">
                            <LinkedInIcon />
                        </a>
                        <a href="https://github.com/ahsanofficial" target="_blank" rel="noopener noreferrer" className="icon i-github" data-aos="fade-up">
                            <GithubIcon />
                        </a>
                        <a href="https://twitter.com/imAhsanmirza" target="_blank" rel="noopener noreferrer" className="icon i-twitter" data-aos="fade-up">
                            <TwitterIcon />
                        </a>
                        <a href="https://instagram.com/ahsan_beg_official/" target="_blank" rel="noopener noreferrer" className="icon i-instagram" data-aos="fade-left">
                            <InstagramIcon />
                        </a>
                    </div>
                </div>
            </HomePageStyled>
        </div>
    )
}
export default HomePage